import type { FirebaseApp } from "firebase/app";
import { browserLocalPersistence, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import { initializeAuthOnce } from "./firebaseAuthInstance";

export function initializePlatformAuth(app: FirebaseApp) {
  return initializeAuthOnce(app, () => initializeAuth(app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  }));
}
